export class QueryHelper {
  static readonly brand = (
    brand: string,
    fallbackBrand?: string
  ): Record<string, string> => {
    if (fallbackBrand) {
      return {
        'fields.brandCode.sys.contentType.sys.id': 'brand',
        'fields.brandCode.fields.code[in]': `${brand},${fallbackBrand}`,
      };
    }
    return {
      'fields.brandCode.sys.contentType.sys.id': 'brand',
      'fields.brandCode.fields.code': brand,
    };
  };

  static readonly slug = (
    slug: string | undefined | null
  ): Record<string, any> =>
    slug ? { 'fields.slug': slug } : { 'fields.slug[exists]': false };

  static readonly zone = (
    zone: string | undefined | null
  ): Record<string, any> =>
    zone ? { 'fields.zone': zone } : { 'fields.zone[exists]': false };
}
